﻿
/**
 * Created by Administrator on 2017/9/22.
 */
import Vue from 'vue'
Vue.component('fs-modal', {
  props: {
          showAgreementModal:''
       },
    template:
                 '<div class="frameTable" v-show=\"showAgreementModal\">' +
                      '<div class="frameHead">' +
                        '<ul><li class="part-name">理赔条款</li>' +
                         '<li class="close-button"><a @click=\"toggleAgreementModal\">×</a></li>' +
                        '</ul>' +
                       '</div>' +
                      '<div class="content" style="padding:0px">' +
                          '<iframe name=\"content\" style="width:100%;min-height:350px" frameborder="0" :src="urlId" ></iframe>' +
                      '</div>' +
                      '<div class="framePwBtn">' +
                          '<span><a class="sureYellow" @click=\"toggleAgreementModal\">我知道了</a></span>' +
                      '</div>' +
                    '</div>',

  data: function () {
    return {
      urlId:this.$apiAll+'Clause/ClaimClause.htm',
    };
  },
  mounted: function () {

  },
  methods: {
    toggleAgreementModal: function() {
      this.$emit('toggle-agreement-modal')
    },
  }
})







//////////////////
// WEBPACK FOOTER
// ./static/js/clause.js
// module id = null
// module chunks = 